import React from 'react';
import {useSelector} from "react-redux";
import DesktopCash from "./DeskTopCash/index.jsx";
import MobileCash from "./MobileCash/index.jsx";

const Cash = React.memo(function () {
    const isMobile = useSelector((state) => state.user.isMobile);
    return isMobile ?  <MobileCash /> : <DesktopCash />
}, (prevProps, nextProps) => prevProps.isMobile === nextProps.isMobile);
export default Cash